import map from "lodash/map";

import CloseBox, { CloseButtonPosition } from "VerticalModalList/CloseBox";
import PropTypes from "prop-types";
import React from "react";

import VerticalModalListContainer from "containers/VerticalModalListContainer";
import { Hero } from "VerticalModalList";
import styles from "./ChapterList.css";
import ChapterListItem from "./ChapterListItem";

export default class ChapterList extends React.PureComponent {
  static propTypes = {
    chapters: PropTypes.array.isRequired,
    onChapterClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  renderHero() {
    return (
      <Hero>
        <CloseBox
          className={styles.closeBox}
          closePosition={CloseButtonPosition.RIGHT}
          onClose={this.props.onClose}
        />
      </Hero>
    );
  }

  renderChapterList() {
    return map(this.props.chapters, (chapterId) => (
      <ChapterListItem
        chapterId={chapterId}
        handleItemClick={this.props.onChapterClick}
        key={`chapter_${chapterId}`}
      />
    ));
  }

  render() {
    return (
      <VerticalModalListContainer
        {...this.props}
        aria-label="Chapter List"
        className={styles.root}
        handleClose={this.props.onClose}
        hero={this.renderHero()}
      >
        {this.renderChapterList()}
      </VerticalModalListContainer>
    );
  }
}
